import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { createSelector } from 'reselect'
import ErrorBoundary from 'containers/ErrorBoundary/components'
import getCurrentUserSelector from 'modules/users/selectors/get-current'
import {
  createErrorUtil,
  saveErrorUtil
} from 'utils/error'
import { ERRORS_SOURCE } from 'modules/errors/constants'
import { getObjectUtil } from 'packages/src'

class ErrorBoundaryContainer extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      hasError: false
    }
  }

  componentDidCatch (error) {
    console.error('error: ', error)
    // Display fallback
    this.setState({ hasError: true })
    const data = createErrorUtil(error, this.props.currentUser, {
      message: getObjectUtil(error, 'message'),
      source: ERRORS_SOURCE.WEB_FRONTEND
    })
    saveErrorUtil(data)
  }

  render () {
    if (this.state.hasError) {
      return <ErrorBoundary />
    }
    return this.props.children
  }
}

ErrorBoundaryContainer.propTypes = {
  children: PropTypes.element.isRequired,
  currentUser: PropTypes.object
}

const select = () => createSelector(
  getCurrentUserSelector(),
  (
    currentUser
  ) => ({
    currentUser
  })
)
export default connect(select)(ErrorBoundaryContainer)
